import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import LinearProgress from '@material-ui/core/LinearProgress'
import { Icon } from 'components/icons'
import { localized } from 'decorators'
import { format } from 'utils/stringUtilities'

const ItemIcon = props => {
  switch (props.actionType) {
    case 0: return <Icon name='file-excel-o' />
    default:
      return <Icon name='check' /> // <DoneAllIcon />
  }
}

const NoBackgroundActionItem = (props) => {
  return (
    <ListItem>
      <ListItemIcon>
        <ItemIcon backgroundAction={-1} />
      </ListItemIcon>
      <ListItemText primary={props.localize('notifications.noNotification')} />
    </ListItem>
  )
}

export const BackgroundActionItem = localized((props) => {
  const { backgroundAction, localize } = props
  if (backgroundAction) {
    const key = `notifications.action_${backgroundAction.actionType}`
    const primary = `${format(localize(key), backgroundAction.targetName)} (${backgroundAction.percentage}%)`
    return (
      <ListItem>
        <ListItemIcon>
          <ItemIcon {...backgroundAction} />
        </ListItemIcon>
        <ListItemText
          disableTypography
          primary={primary}
          secondary={<LinearProgress variant='determinate' value={backgroundAction.percentage} />}
        />
      </ListItem>
    )
  }
  return (<NoBackgroundActionItem {...props} />)
})

